import { ref } from 'vue';

const STORAGE_KEY = 'veyop-recent-colors';
const EVENT_NAME = 'veyop:recent-colors';
const MAX_RECENT = 8;

function load(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(parsed)
      ? parsed.filter((color): color is string => typeof color === 'string').slice(0, MAX_RECENT)
      : [];
  } catch {
    return [];
  }
}

export const recentColors = ref<string[]>(typeof window === 'undefined' ? [] : load());

if (typeof window !== 'undefined') {
  window.addEventListener(EVENT_NAME, (event) => {
    const colors = (event as CustomEvent<unknown>).detail;
    if (Array.isArray(colors)) {
      recentColors.value = colors.filter((color): color is string => typeof color === 'string').slice(0, MAX_RECENT);
    }
  });
}

export function addRecentColor(color: string): void {
  const normalized = String(color).toUpperCase();
  const next = [normalized, ...recentColors.value.filter((entry) => entry !== normalized)].slice(0, MAX_RECENT);
  recentColors.value = next;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable; keep recents for this page session.
  }
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: next }));
}
